import { isPlainObject } from 'remeda';
import { parseJsonSafely } from 'src/utils/objects';

export interface ParsedCustomAttributes {
  values: Record<string, unknown>;
  error: string | null;
}

export function parseStoredAttributes(raw: string | null | undefined): ParsedCustomAttributes {
  if (!raw) {
    return { values: {}, error: null };
  }

  const parsed = parseJsonSafely<Record<string, unknown>>(raw, isPlainObject);

  if (parsed) {
    return { values: parsed, error: null };
  }

  return { values: {}, error: 'Custom attributes payload is malformed' };
}

export function resolveStoredValue(
  values: Record<string, unknown>,
  key: string,
  fallback: unknown,
): unknown {
  return key in values ? values[key] : fallback;
}
